export default {
    RESUME: 'mediaResume',
    REPLAY: 'mediaReplay',
    PAUSE: 'mediaPaused',
    START: 'mediaStart',
    COMPLETE: 'mediaComplete',
    EMBED_USER_CLOSED: 'embedUserClosed',
    AD_START: 'adStart',
    AD_COMPLETE: 'adComplete',
    META_DATA_LOADED: 'metaDataLoaded',
    EMBED_PLAYER_CREATED: 'embedPlayerCreated',
    EMBED_PLAYER_READY: 'embedPlayerStart',
    EMBED_PREVIEW_READY: 'embedVideoPreview',
    SHOW_CLICK_TO_PLAY: 'showClickToPlay',
    SHOW_LEAVE_BEHIND: 'showLeavebehind',
    SHOW_PLAYER: 'showPlayer',
    STOP: 'MEDIA_STOP',
    SET_CLIP_METADATA: 'setClipMetadata',
    CLIP_METADATA_SET: 'clipMetadataSet',
    UPDATE_PLAYLIST: 'updatePlaylist',
    PLAYLIST_UPDATED: 'playlistUpdated',
    LEAVE_BEHIND_COUNTDOWN_COMPLETE: 'leaveBehindCountdownComplete',
    LEAVE_BEHIND_NEXT_CLIP_CLICK: 'leaveBehindNextClipClick',
};
